<template>
  <div class="wf-sidebar-main">
    <div class="wf-sidebar-search-wrap">
      <input
        :value="searchValue"
        class="wf-input wf-sidebar-search-input"
        type="text"
        placeholder="Search nodes..."
        @input="emit('update:searchValue', $event.target.value)"
      />
    </div>
    <div class="wf-sidebar-list">
      <div v-for="group in filteredGroups" :key="`group-${group.id}`" class="wf-sidebar-group">
        <div class="wf-sidebar-group-title">{{ group.label }}</div>
        <button
          v-for="nodeDef in group.nodes"
          :key="`node-def-${nodeDef.id}`"
          class="wf-sidebar-item"
          draggable="true"
          @dragstart="emit('dragstart', $event, nodeDef)"
          @click="emit('addnode', nodeDef)"
        >
          <div class="wf-sidebar-item-main">
            <img v-if="nodeDef.image !== undefined && nodeDef.image !== null && nodeDef.image !== ''" :src="nodeDef.image" class="wf-sidebar-item-img" />
            <div v-else-if="nodeDef.icon !== undefined && nodeDef.icon !== null && nodeDef.icon !== ''" class="wf-sidebar-item-icon-wrap">
              <Icon :icon="nodeDef.icon" class="wf-sidebar-item-icon" />
            </div>
            <div v-else class="wf-sidebar-item-icon-wrap">
              <Icon icon="tabler:puzzle" class="wf-sidebar-item-icon" />
            </div>
            <div class="wf-sidebar-item-text">
              <span class="wf-sidebar-item-label">{{ nodeDef.label }}</span>
              <span class="wf-sidebar-item-desc">{{ nodeDef.description }}</span>
            </div>
          </div>
        </button>
      </div>
    </div>
  </div>
</template>

<script setup>
import { Icon } from '@iconify/vue';

defineProps({
  searchValue: {
    type: String,
    default: ''
  },
  filteredGroups: {
    type: Array,
    default: () => []
  }
});

const emit = defineEmits(['update:searchValue', 'dragstart', 'addnode']);
</script>

<style scoped>
.wf-sidebar-main {
  flex: 1;
  min-height: 0;
  display: flex;
  flex-direction: column;
  overflow: hidden;
}

.wf-sidebar-search-wrap {
  padding: 8px 10px 0 10px;
}

.wf-sidebar-search-input {
  width: 100%;
}

.wf-sidebar-list {
  padding: 8px 10px 10px 10px;
  overflow: auto;
  min-height: 0;
  flex: 1;
}

.wf-sidebar-group {
  margin-bottom: 14px;
}

.wf-sidebar-group:last-child {
  margin-bottom: 0;
}

.wf-sidebar-group-title {
  font-size: 0.62rem;
  color: #64748b;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.04em;
  margin-bottom: 8px;
  padding-left: 2px;
}

.wf-sidebar-item {
  width: 100%;
  padding: 7px 8px;
  margin-bottom: 5px;
  text-align: left;
  display: flex;
  flex-direction: column;
  cursor: pointer;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  transition: border-color 0.15s ease, background-color 0.15s ease;
}

.wf-sidebar-item:hover {
  border-color: #94a3b8;
  background: #fafbfc;
}

.wf-sidebar-item:active {
  transform: translateY(0);
}

.wf-sidebar-item:last-child {
  margin-bottom: 0;
}

.wf-sidebar-item-main {
  display: flex;
  align-items: flex-start;
}

.wf-sidebar-item-main > * + * {
  margin-left: 8px;
}

.wf-sidebar-item-img {
  width: 20px;
  height: 20px;
  object-fit: contain;
  flex-shrink: 0;
  border-radius: 4px;
}

.wf-sidebar-item-icon-wrap {
  width: 20px;
  height: 20px;
  border-radius: 3px;
  background: #f1f5f9;
  color: #475569;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  flex-shrink: 0;
}

.wf-sidebar-item-icon {
  width: 13px;
  height: 13px;
}

.wf-sidebar-item-text {
  display: flex;
  flex-direction: column;
}

.wf-sidebar-item-label {
  font-size: 0.78rem;
  color: #0f172a;
  font-weight: 600;
}

.wf-sidebar-item-desc {
  font-size: 0.65rem;
  color: #64748b;
  margin-top: 2px;
  line-height: 1.35;
}

.wf-input {
  padding: 5px 8px;
  font-size: 0.78rem;
  background: #ffffff;
  border: 1px solid #e2e8f0;
  border-radius: 4px;
  color: #0f172a;
  transition: border-color 0.15s ease;
  box-shadow: none;
}

.wf-input:focus {
  outline: none;
  border-color: #6366f1;
  box-shadow: 0 0 0 3px rgba(99, 102, 241, 0.2);
}
</style>
